/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, Component} from '@angular/core';

import {AbstractField} from './abstract-field';

/**
 * Fake field that introduces an empty space.
 */
@Component({
  selector: 'gp-form-field-blank',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlankFieldComponent extends AbstractField {
}
